<template>
    <div class="bg-grey-100 py-2">
        <AppContainer>
            <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-y-8 md:gap-y-0">
                <div>
                    <ul class="space-y-2">
                        <li class="font-bold">Top Tyre Brands</li>

                        <li v-for="brand of summaryData.brands" class="hover:text-primary hover:underline">
                            <a :href="route('brands.show', brand)">
                                {{ brand.name }}
                            </a>
                        </li>
                    </ul>
                </div>
                <div>
                    <ul class="space-y-2">
                        <li class="font-bold">Reviews by Season</li>

                        <li v-for="page of summaryData.tyre_pages" class="hover:text-primary hover:underline">
                            <a :href="route('pages.show', page)">
                                {{ page.name }}
                            </a>
                        </li>
                    </ul>
                </div>
                <div>
                    <ul class="space-y-2">
                        <li class="font-bold">Top Performance Tyres</li>

                        <li v-for="product of summaryData.premium" class="hover:text-primary hover:underline">
                            <a :href="route('products.show', product)">
                                {{ product.name }}
                            </a>
                        </li>
                    </ul>
                </div>
                <div>
                    <ul class="space-y-2 mb-4">
                        <li class="font-bold">More from {{ usePage().props.value.config.name }}</li>

                        <li v-if="route().has('news.index')" class="hover:text-primary hover:underline">
                            <a :href="route('news.index')">Tyre News</a>
                        </li>

                        <li v-if="route().has('advice.index')" class="hover:text-primary hover:underline">
                            <a :href="route('advice.index')">Tyre Help & Advice</a>
                        </li>

                        <li class="hover:text-primary hover:underline">
                            <a :href="route('reviews.create')">Submit a Review</a>
                        </li>

                        <li class="hover:text-primary hover:underline cursor-pointer"
                            @click="showCookiePopup">
                            Manage Cookies
						</li>

                        <li class="hover:text-primary hover:underline">
                            <a href="/privacy-policy.pdf" target="_blank">Privacy Policy</a>
                        </li>
                    </ul>

                    <div class="flex items-center space-x-4">
                        <a target="_blank" href="https://www.youtube.com/channel/UCKCkxxpQ7-Wdn_OOyxgfvwA">
                            <FontAwesomeIcon size="2x" :icon="['fab', 'youtube']"></FontAwesomeIcon>
                        </a>
                        <a target="_blank"
                           href="https://www.instagram.com/tyreseeker/">
                            <FontAwesomeIcon size="2x" :icon="['fab', 'instagram']"></FontAwesomeIcon>
                        </a>
                        <a target="_blank" href="https://www.facebook.com/tyreseekeruk/">
                            <FontAwesomeIcon size="2x" :icon="['fab', 'facebook-f']"></FontAwesomeIcon>
                        </a>
                    </div>
                </div>
            </div>

            <hr class="border-grey-200 mb-4 mt-8">

            <div class="flex items-center flex-col lg:flex-row gap-4">
                <p class="text-dark text-center lg:text-left flex-grow">
                    &copy; {{ currentYear }} All Rights Reserved | {{ usePage().props.value.config.name }} is a service
                    from
                    Trusted Checks Ltd
                </p>

                <a class="text-dark order-first lg:order-last" href="mailto:info@tyreseeker.co.uk">
                    info@tyreseeker.co.uk
                </a>

                <!--                <div class="flex items-center gap-2">-->
                <!--                    <a class="text-dark underline hover:text-primary" href="#">Terms & conditions</a>-->
                <!--                    <a class="text-dark underline hover:text-primary" href="#">Manage cookies</a>-->
                <!--                    <a class="text-dark underline hover:text-primary" href="#">Privacy policy</a>-->
                <!--                </div>-->
            </div>
        </AppContainer>
    </div>
    <CookieModal
        :performance-cookie="usePage().props.value.cookies.performance"
        :advertising-cookie="usePage().props.value.cookies.advertising"
        :functional-cookie="usePage().props.value.cookies.functional"
        :show-cookie-modal="showCookieModal"
        @toggleModal="toggleModal()"
        @closeModal="toggleModal()"
    ></CookieModal>
</template>

<script setup>
import {usePage} from "@inertiajs/inertia-vue3";
import AppContainer from "@/Layouts/AppContainer";
import {onMounted, reactive, ref} from "vue";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {useDates} from "@/Composables/useDates";
import CookieModal from "@/Components/Modals/CookieModal";

let summaryData = ref({});
let showCookieModal = ref(false);

async function getFooterSummary() {
    const response = await axios.get(route("footer.summary"));

    summaryData.value = response.data;
}

function showCookiePopup() {
    showCookieModal.value = true;
}

const {currentYear} = useDates();

onMounted(() => getFooterSummary());

function toggleModal() {
    showCookieModal.value = false;
}
</script>

<style scoped>

</style>
